<template>
  <div>
    <div class="pointer d-flex row justify-start" @click="openFilters" v-if="extraFiltersTags.length">
      <div class="flex xs1">
        <v-btn fab small><v-icon>fa fa-filter</v-icon></v-btn>
      </div>
      <div class="ml-2">
        <v-chip
          v-for="(item, index) in extraFiltersTags"
          :key="index"
          :close="false"
          small
          class="ma-1">
          {{item}}
        </v-chip>
      </div>
    </div>
    <v-btn @click="openFilters" :block="buttonBlock" v-if="!extraFiltersTags.length">
      <v-icon small left>fa fa-filter</v-icon> Extra Filters
    </v-btn>

    <v-dialog
        transition="dialog-bottom-transition"
        scrollable
        max-width="600"
        v-model="modalOpen">
      <v-card>
        <v-card-title class="headline grey lighten-2 text-xs-center" primary-title>
          Extra Filters
        </v-card-title>
        <v-card-text>
          <v-layout mb-4>
            <v-flex sm4 xs12>
              <v-select
                :items="[{ text: 'Date Created', value: 'dateCreated' }, { text: 'Date Updated', value: 'dateUpdated' }]"
                dense
                hide-details
                style="width: 100%"
                solo
                v-model="localFilters.dateCategory"
                placeholder="Date type"
                :menu-props="{ offsetY: true }"
              />
            </v-flex>
            <v-flex sm4 xs12 pl-2>
              <st-date-field
                :id="dateFromId"
                v-model="localFilters.dateFrom"
                label="From"
                :to-date-id="dateToId"
              />
            </v-flex>
            <v-flex sm4 xs12 pl-2>
              <st-date-field
                :id="dateToId"
                v-model="localFilters.dateTo"
                label="To"
                :from-date-id="dateFromId"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap mb-4>
            <v-flex class="text-xs-right font-weight-bold" sm4 pr-3>
              Wallet balance
            </v-flex>
            <v-flex sm8 class="d-flex row">
              <v-select
                :items="[{ text: 'Equal to', value: '=' }, { text: 'Less than', value: '<' }, { text: 'Greater than', value: '>' }]"
                dense
                hide-details
                solo
                v-model="localFilters.balanceFilterOperator"
                :menu-props="{ offsetY: true }"
              />
              <v-text-field
                class="ml-2"
                placeholder="Enter number"
                clearable
                v-model="localFilters.balanceFilterValue"
                type="number"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap mb-4>
            <v-flex class="text-xs-right font-weight-bold" sm4 pr-3>
              Tickets purchased
            </v-flex>
            <v-flex sm8 class="d-flex row">
              <v-select
                :items="[{ text: 'Equal to', value: '=' }, { text: 'Less than', value: '<' }, { text: 'Greater than', value: '>' }]"
                dense
                hide-details
                solo
                v-model="localFilters.ticketsFilterOperator"
                :menu-props="{ offsetY: true }"
              />
              <v-text-field
                :rules="[v => v < 0 ? 'Please enter a number 0 or higher' : true]"
                class="ml-2"
                placeholder="Enter number"
                min="0"
                clearable
                v-model="localFilters.ticketsFilterValue"
                type="number"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap mb-4>
            <v-flex class="text-xs-right font-weight-bold" sm4 pr-3>
              Days since last trip
            </v-flex>
            <v-flex sm8 class="d-flex row">
              <v-text-field
                :rules="[v => v < 0 ? 'Please enter a number 0 or higher' : true]"
                class="ml-2"
                placeholder="Enter number"
                min="0"
                clearable
                v-model="localFilters.daysOfNoTripsFilterValue"
                type="number"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap mb-4>
            <v-flex class="text-xs-right font-weight-bold" sm4 pr-3>
              Beacon
            </v-flex>
            <v-flex sm8>
              <v-select
                :items="beaconFilterItems"
                dense
                hide-details
                solo
                clearable
                v-model="localFilters.beaconFilter"
                placeholder="All passengers"
                :menu-props="{ offsetY: true }"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap mb-4>
            <v-flex class="text-xs-right font-weight-bold" sm4 pr-3>
              Ticket/top-up frequency
            </v-flex>
            <v-flex sm8 class="d-flex row align-center">
              <v-switch
                v-model="localFilters.ticketFrequencyFilterEnabled"
                class="ml-2 mt-0"
                color="primary"
                hide-details
              />
              <v-select
                class="ml-2"
                :items="ticketFrequencyMinPurchasesPerWeekItems"
                item-text="text"
                item-value="value"
                label="Min. tickets/top-ups per week"
                :disabled="!localFilters.ticketFrequencyFilterEnabled"
                v-model="localFilters.ticketFrequencyMinPurchasesPerWeek"
              />
              <v-select
                class="ml-2"
                :items="ticketFrequencyEvaluationWeeksItems"
                item-text="text"
                item-value="value"
                label="Weeks (from current date)"
                :disabled="!localFilters.ticketFrequencyFilterEnabled"
                v-model="localFilters.ticketFrequencyEvaluationWeeks"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="warning" flat @click="modalOpen = false">
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn color="primary" @click="applyFilters">Filter</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
